import styled from "styled-components";
import {ApresentacaoImagem, Card} from "../Componentes/styleComponentes";

export const ImagemEdital = styled(ApresentacaoImagem)`

   animation: ${props => props.scroll && 'slide-in-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'};
   
@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
            transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
    opacity: 1;
  }
}

`;




export const CardEditais = styled(Card)`

   animation: ${props => props.scroll && 'slide-left 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'};
   
   @keyframes slide-left {
  0% {
    -webkit-transform: translateX(-1000px);
            transform: translateX(-1000px);
  }
  100% {
    -webkit-transform: translateX(0px);
            transform: translateX(0px);
            opacity: 1;
  }
}

`;

